import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/calls/call-history')({
  staticData: { team: 'fe-phone-experience' },
});
